import { v4 as uuidv4, validate as isUuid } from "uuid";

const SESSION_KEY = "correlationSessionId";

export interface CorrelationStorage {
  get: (key: string) => string | null;
  set: (key: string, value: string) => void;
  remove: (key: string) => void;
}

export const createSessionStore = ({
  storage,
}: {
  storage: CorrelationStorage;
}) => ({
  ensure: (): string => {
    const existing = storage.get(SESSION_KEY);
    if (existing && isUuid(existing)) return existing;

    const id = uuidv4();
    storage.set(SESSION_KEY, id);
    return id;
  },
  clear: (): void => {
    storage.remove(SESSION_KEY);
  },
});
